import NodesCreator from "./NodesCreator/NodesCreator";
import NodesMerger from "./NodesMerger/NodesMerger";

export default class NodesGenerator {
    // Public:
    compute(rawData) {
        this.rawData = rawData;
        this.createNodes();
        this.mergeNodes();
        this.numberNodes();
        return this.nodes;
    }

    // Private
    createNodes() {
        const rawData = this.rawData;
        const nodes = new NodesCreator().compute(rawData);
        this.nodes = nodes;
    }

    mergeNodes() {
        let nodes = this.nodes;
        nodes = new NodesMerger().compute(nodes);
        this.nodes = nodes;
    }

    numberNodes() {
        let nodes = this.nodes;
        for (let i = 0; i < nodes.length; i++) {
            const node = nodes[i];
            node.number = i;
        }
        this.nodes = nodes;
    }
}
